import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/manage_group',
  component: Layout,
  redirect: '/manage_group/index',
  name: 'ManageGroup',
  meta: {
    title: '组管理',
    i18n: 'route.tabbar',
    icon: 'i-ic:round-tab',
  },
  children: [
    {
      path: 'index',
      name: 'ManageGroupIndex',
      component: () => import('@/views/manage_group/index.vue'),
      meta: {
        title: '组管理',
        menu: false,
        breadcrumb: false,
        activeMenu: '/manage_group',
      },
    },
  ],
}

export default routes
